import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/breadcrumb/breadcrumb-img-1.png'


const _hoisted_1 = { class: "breadcrumb-wrap" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-lg-6 col-md-8 col-sm-8" }
const _hoisted_5 = { class: "breadcrumb-title" }
const _hoisted_6 = { class: "breadcrumb-menu list-style" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.pageTitle), 1),
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode("Home ")
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, _toDisplayString(_ctx.mainTitle), 1)
            ])
          ])
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-lg-6 col-md-4 col-sm-4" }, [
          _createElementVNode("div", { class: "breadcrumb-img" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Image"
            })
          ])
        ], -1))
      ])
    ])
  ]))
}